import classNames from "classnames";

export const SharpPoly = ({text, bgColor, color}) => {
    return (
         <div className="rect-poly">
            <div 
                className={classNames("polygon-shape",'rev')}
                style={{backgroundColor: bgColor}} 
            />
            <div 
                className="sqr-rect"
                style={{backgroundColor: bgColor}}
            >
            <div className="rect-text" style={{color: color}}>{text}</div>
            </div>

            <div className={classNames("polygon-shape",'fwd')} style={{backgroundColor: bgColor}} />
        </div>
    )
}